import { useParams } from "react-router-dom";
import OrganisationEditComponent from "screens/components/OrganisationEditComponent"

function OrganisationEdit() {
    const {organisationId} = useParams();
    return <OrganisationEditComponent organisationId={organisationId} />
}

export default OrganisationEdit;
